import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import apiService from '../../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import MenuVerDiagnosticos from './MenuVerDiagnosticos';
import ButtonsMenu from '../../Utils/ButtonsMenu';


export default function DiagSeguimientoRetorno(){
    const navigate = useNavigate();
    const [Cargando, setCargando] = useState(false);
    const [datosSeguimientoRetorno, setDatosSeguimientoRetorno] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10); 
    const [swalProps, setSwalProps] = useState();
    
    useEffect(() => {
        fetchData(currentPage, perPage);
    }, []);
    const fetchData = async (page, rowsPerPage) => {
        let url = `/caracterizacion/diagnosticos/listardatoseguimientoretorno?page=${page}&limit=${rowsPerPage}`;
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            setDatosSeguimientoRetorno(result.data);
            setTotalRows(result.meta.total);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
        
        
    };
    const columns = [
        {
            name: 'Acciones',
            cell: row => (
            <div>
                <button onClick={() => verAtencionesPersona(row)} 
                        style={{backgroundColor: 'skyblue'}} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Ver atenciones de la persona">
                <i className="fas fa-list nav-icon"></i>
                </button>
                
            </div>
            ),
            ignoreRowClick: true,
            width: "1%"
        },
        { name: 'Identificación', selector: row => row.per_idpersona, sortable: true, width: "1%" },
        { name: 'Nombre', selector: row => row.nombre, sortable: true, width: "2%"},
        { name: 'Fecha seguimiento', selector: row => row.ret_fecha, sortable: true, width: "2%"},
        { name: 'VALORACIÓN SITUACIÓN INICIAL ENCONTRADA', selector: row => row.ret_situacioninicial, sortable: true, width: "2%"},
        { name: 'Estado del techo', selector: row => row.ret_estadotecho, sortable: true, width: "2%"},
        { name: 'Estado de pisos', selector: row => row.ret_estadopisos, sortable: true, width: "2%"},
        { name: 'Estado de baños', selector: row => row.ret_estadobanos, sortable: true, width: "2%"},
        { name: 'Estado de paredes', selector: row => row.ret_estadoparedes, sortable: true, width: "2%"},
        { name: 'Estado de cocina', selector: row => row.ret_estadococina, sortable: true, width: "2%"},
        { name: 'La vivienda cuenta con servicio de alcantarillado', selector: row => row.ret_servicioalcantarillado, sortable: true, width: "2%"},
        { name: 'La vivienda cuenta con pozo séptico', selector: row => row.ret_serviciopozoseptico, sortable: true, width: "2%"},
        { name: 'La vivienda cuenta con servicio de acueducto', selector: row => row.ret_servicioacueducto, sortable: true, width: "2%"},
        { name: 'La vivienda cuenta con servicio de energía', selector: row => row.ret_servicioenergia, sortable: true, width: "2%"},
        { name: 'Tiene deudas de servicios públicos', selector: row => row.ret_deudasserviciospublicos, sortable: true, width: "2%"},
        { name: 'Valor deudas de servicios públicos', selector: row => row.ret_deudasserviciospublicosvalor, sortable: true, width: "2%"},
        { name: 'Tiene deudas de impuesto predial', selector: row => row.ret_deudasimpuestopredial, sortable: true, width: "2%"},
        { name: 'Valor deudas de impuesto predial', selector: row => row.ret_deudasimpuestopredialvalor, sortable: true, width: "2%"},
        { name: 'Tiene deudas de valorización', selector: row => row.ret_deudasvalorizacion, sortable: true, width: "2%"},
        { name: 'Valor deudas de valorización', selector: row => row.ret_deudasvalorizacionvalor, sortable: true, width: "2%"},
        { name: 'Tiene deudas de préstamo de banco/cooperativa', selector: row => row.ret_deudasbancos, sortable: true, width: "2%"},
        { name: 'Valor deudas de préstamo de banco/cooperativa', selector: row => row.ret_deudasbancosvalor, sortable: true, width: "2%"},
        { name: 'Tiene acceso al programa Familias en Acción', selector: row => row.ret_familiasenaccion, sortable: true, width: "2%"},
        { name: 'Motivos Familias en Acción', selector: row => row.ret_familiasenaccionmotivos, sortable: true, width: "2%"},
        { name: 'Tiene acceso al programa Red Unidos', selector: row => row.ret_redunidos, sortable: true, width: "2%"},
        { name: 'Motivos Red Unidos', selector: row => row.ret_redunidosmotivos, sortable: true, width: "%"},
        { name: 'Fecha última AH entregada por Acción Social', selector: row => row.ret_ahaccionsocialfecha, sortable: true, width: "2%"},
        { name: 'Valor del último giro entregado por Acción Social', selector: row => row.ret_ahaccionsocialvalor, sortable: true, width: "2%"},
        { name: 'Afiliación en salud', selector: row => row.descripcionsalud, sortable: true, width: "2%"},
        { name: 'Los niños se encuentran actualmente estudiando', selector: row => row.ret_ninosestudiando, sortable: true, width: "2%"},
        { name: 'Situación por la que no están estudiando', selector: row => row.razon_noestudio, sortable: true, width: "2%"},
        { name: 'Hogar comunitario (ICBF)', selector: row => row.ret_icbfhogarcomunitario, sortable: true, width: "2%"},
        { name: 'Restaurante escolar (ICBF)', selector: row => row.ret_icbfrestauranteescolar, sortable: true, width: "2%"},
        { name: 'Clubes juveniles (ICBF)', selector: row => row.ret_icbfclubesjuveniles, sortable: true, width: "2%"},
        { name: 'Madres gestantes/lactantes (ICBF)', selector: row => row.ret_icbfmadresgestantes, sortable: true, width: "2%"},
        { name: 'Programa de cero a siempre (ICBF)', selector: row => row.ret_icbfcerosiempre, sortable: true, width: "2%"},
        { name: 'Programa mis derechos primero (Auto 251) (ICBF)', selector: row => row.ret_icbfmisderechosprimero, sortable: true, width: "2%"},
        { name: 'Programa atención mujeres (Auto 092) (ICBF)', selector: row => row.ret_icbfatencionmujeres, sortable: true, width: "2%"},
        { name: 'Atención psicosocial (SSSA)', selector: row => row.ret_sssaatencionpsicosocial, sortable: true, width: "2%"},
        { name: 'Programa adulto mayor (SSSA)', selector: row => row.ret_sssaadultomayor, sortable: true, width: "2%"},
        { name: 'Programa mis derechos primero (Auto 251) (SSSA)', selector: row => row.ret_sssamisderechosprimero, sortable: true, width: "2%"},
        { name: 'Programa atención mujeres (Auto 092) (SSSA)', selector: row => row.ret_sssaatencionmujeres, sortable: true, width: "2%"},
        { name: 'Programa de alimentación al adulto mayor Juan Luis Londoño (Tercera Edad)', selector: row => row.ret_teadultomayor, sortable: true, width: "2%"},
        { name: 'Restaurante (Tercera Edad)', selector: row => row.ret_terestaurante, sortable: true, width: "2%"},
        { name: 'Subsidio económico (Tercera Edad)', selector: row => row.ret_tesubsidioeconomico, sortable: true, width: "2%"},
        { name: 'Clubes de vida (Tercera Edad)', selector: row => row.ret_teclubesvida, sortable: true, width: "2%"},
        { name: 'Subsidios de vivienda de interés social rural - VIS rural demanda nacional (MIN. AGRIC.)', selector: row => row.ret_masubsidiosvisrural, sortable: true, width: "2%"},
        { name: 'Líneas de crédito agropecuario (MIN. AGRIC.)', selector: row => row.ret_macreditoagropecuario, sortable: true, width: "2%"},
        { name: 'Subsidio de tierras (MIN. AGRIC.)', selector: row => row.ret_masubsidiotierras, sortable: true, width: "2%"},
        { name: 'Subsidio integral para conformación de empresas básicas agropecuarias (MIN. AGRIC.)', selector: row => row.ret_masubsidioconfempresas, sortable: true, width: "2%"},
        { name: 'Programa Jóvenes Rurales Emprendedores (SENA) (P. JOVENES)', selector: row => row.ret_jjovenesrurales, sortable: true, width: "2%"},
        { name: 'Capacitaciones Jóvenes en Acción (P. JOVENES)', selector: row => row.ret_jcapacjovenesaccion, sortable: true, width: "2%"},
        { name: 'Generó impacto el Plan Productivo Diferencial en la economía familiar', selector: row => row.ret_planproductivodiferencial, sortable: true, width: "2%"},
        { name: 'Autoconsumo', selector: row => row.ret_autoconsumo, sortable: true, width: "2%"},
        { name: 'Trueque', selector: row => row.ret_trueque, sortable: true, width: "2%"},
        { name: 'El cultivo está en fase de inicio', selector: row => row.ret_cultivofaseinicio, sortable: true, width: "2%"},
        { name: 'El cultivo está en producción', selector: row => row.ret_cultivoproduccion, sortable: true, width: "2%"},
        { name: 'Compra y venta del producto', selector: row => row.ret_compraventaproducto, sortable: true, width: "2%"},
        { name: 'Aceptación del servicio', selector: row => row.ret_aceptacionservicio, sortable: true, width: "2%"},
        { name: 'Captación de clientes', selector: row => row.ret_captacionclientes, sortable: true, width: "2%"},
        { name: 'Rango de ingresos mensuales', selector: row => row.ret_rangoingresos, sortable: true, width: "2%"},
        { name: 'Observaciones y/o comentarios', selector: row => row.ret_observaciones, sortable: true, width: "2%"},
        { name: 'Qué requeriría para fortalecer esta actividad económica', selector: row => row.fortalecer_actividad, sortable: true, width: "2%"},
        { name: 'Cómo se encuentra la dinámica familiar', selector: row => row.ret_dinamicafamiliar, sortable: true, width: "2%"},
        { name: 'En qué ha avanzado la familia desde el momento del retorno o reubicación', selector: row => row.ret_avancefamilia, sortable: true, width: "2%"},
        { name: 'Meta(s) familar(es)', selector: row => row.ret_metasfamilia, sortable: true, width: "2%"},
        { name: 'Percepción de cada uno de los niños(as) y/o adolescentes desde el momento de retorno o reubicación', selector: row => row.ret_percepcionninosadolecentes, sortable: true, width: "2%"},
        { name: 'Observaciones finales', selector: row => row.ret_observacionesfinales, sortable: true, width: "2%"},
    ];
    
    
    function verAtencionesPersona (row){
        navigate(`/consulta/consultaatenciones/${row.per_idpersona}`);
    };
    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
        fetchData(page, newPerPage);
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, perPage);
      }; 
    async function exportarCSV() {
        setCargando(true);
        const url = `/caracterizacion/diagnosticos/listardatoseguimientoretorno?page=0&limit=0&csv=true`;

        try {
            const response = await apiService.get(url, token, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', 'datos_seguimiento_retorno.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Diagnostico seguimiento retorno</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={`/`} >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to={`/consultas/verdiagnosticos`} >Diagnosticos</NavLink></li>
                        <li className="breadcrumb-item active"> Seguimiento retorno</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuVerDiagnosticos></MenuVerDiagnosticos>
                    <div className="row">
                        <div className="col-md-12">
                            <ButtonsMenu data={datosSeguimientoRetorno} titulo="Seguimiento a retorno" exportarCSV={exportarCSV}/>
                            <div className="card-body table-responsive p-0">
                                <DataTable 
                                    title="Seguimiento a retorno"
                                    columns={columns}
                                    data={datosSeguimientoRetorno}
                                    progressPending={Cargando}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    paginationPerPage={perPage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange} 
                                    noDataComponent="No hay datos para mostrar"
                                >
                                </DataTable> 
                                
                                
                            </div>
                        </div>
                    </div>
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}